<template>
  <div class="productos--consulta--container">
    <h1>Productos de {{proveedor}}</h1>
    <ul>
      <li class="card-producto" v-for="(producto, index) in productos" :key="index">
        <div class="card-producto__picture">

        </div>
        <div class="card-producto__body">
          <p>{{producto.descripcion}}</p>
          <p>{{producto.cantidad}} {{producto.unidad}} {{producto.nombre}}</p>
          <p>$ {{producto.costo}} </p>
          <p v-for="(ti, id) in producto.tipo" :key="id">{{ti}} </p>
          <div class="botones--agregar">
            <div class="bottones--centrar">
              <!--div class="button" @click="agregar(producto)">+</div-->
              <input class="number-items" type="number" name="cantidad" v-model="cantidad">
              <button @click="agregar(producto)">Agregar</button>
              <!--div class="button" @click="quitar(producto)">-</div-->
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment-timezone';
moment.tz.setDefault('America/Mexico_City');

export default {
  name: 'AgregarProductos',
  props: ['id'],
  data(){
    return {
      precio: 20,
      productos: [],
      cantidad: 1,
      combos: [],
      proveedor: 'Taqueria Don Rafa'
    }
  },
  created() {
    const self = this;
    const db = this.$firebase.firestore();
    console.log('AgregarProductos created id: ' + this.id)
    let cliente = db
      .collection("productos")
      .where("proveedor", "==", this.id)
      .get();
    cliente.then(function (querySnapshot) {
      if (!querySnapshot.empty) {
        querySnapshot.forEach(function (doc) {
          console.log(doc.data())
          self.productos.push(doc.data());

        });
      } else {
        console.log('ALgo paso')
      }
    });
  },
  methods: {
    ...mapActions([
      'agregarProductosAPedir'
    ]),
    agregar (producto) {
      producto.id = this.getCurrentClient.numero;
      producto.cantidad = this.cantidad;
      producto.fechaAgregado = moment(new Date()).toDate();
      this.agregarProductosAPedir(producto);
    },
    quitar (producto) {
      console.log('Quitar')
      console.log(producto)
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentClient',
      'getProceso'
    ])
  }
}
</script>

<style lang="sass">
.productos--consulta--container
  height: 100%
  h1
    font-size: 20px
    font-weight: bold
  .card-producto
    height: 260px
    min-width: 160px
    border: 1px solid gray
    border-radius: 6px
    display: grid
    grid-template-rows: 55% 45%
    .card-producto__picture
    .card-producto__body
      font-size: 12px
      position: relative
      .botones--agregar
        display: flex
        flex-direction: row
        height: 45px
        width: 42%
        position: absolute
        justify-content: center
        bottom: 0
        .bottones--centrar
          width: 60%
          display: flex
          flex-direction: row
          justify-content: space-between
          .button
            height: 24px
            width: 24px
            cursor: pointer

  ul
    padding-top:20px
    display: flex
    flex-direction: row
.number-items
  width: 22px
  height: 27px
  padding: 5px
  border: 1px solid #D3D3D3
</style>
